import { SearchBar } from 'components/store/SearchBar';
import { SeachBarWrapper } from 'pages/SearchPage/SearchPage.styled';

export const SearchPage = () => {
  return (
    <SeachBarWrapper>
      <SearchBar />
    </SeachBarWrapper>
  );
};
